import { render, staticRenderFns } from "./downInfo.vue?vue&type=template&id=c866a46e&scoped=true"
import script from "./downInfo.vue?vue&type=script&lang=js"
export * from "./downInfo.vue?vue&type=script&lang=js"
import style0 from "./downInfo.vue?vue&type=style&index=0&id=c866a46e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c866a46e",
  null
  
)

export default component.exports